import {Component} from '@angular/core';
import {AppRoutes} from "../../../enums/routes";
import {PermissionService} from "../../../_auth/permission.service";
import {LocationRoutes} from "../../location/_models/_enums/location-routes";
import {
  BookingReferenceType,
  BookingReferenceTypeLabels
} from "../../../_models/_booking/_enums/booking-reference-type";
import {GetTypes} from "../../../helpers/enum-helpers";
import {
  NavbarItemLargeComponent
} from "../../../x-components/navbar-base/navbar-item-large/navbar-item-large.component";
import {NavbarContainerComponent} from "../../../x-components/navbar-base/navbar-container/navbar-container.component";
import {
  NavbarItemSmallContainerComponent
} from "../../../x-components/navbar-base/navbar-item-small-container/navbar-item-small-container.component";
import {
  NavbarItemSmallComponent
} from "../../../x-components/navbar-base/navbar-item-small/navbar-item-small.component";
import {CommonModule} from "@angular/common";
import {CompanyRoutes} from "../../company/x-models/x-enums/company-routes";

@Component({
  selector: 'app-navbar-devices',
  templateUrl: './navbar-location.component.html',
  imports: [
    CommonModule,
    NavbarItemLargeComponent,
    NavbarContainerComponent,
    NavbarItemSmallContainerComponent,
    NavbarItemSmallComponent
  ],
  styleUrls: ['./navbar-location.component.scss']
})
export class NavbarLocationComponent {
  protected readonly Routes = AppRoutes;
  protected readonly LocationRoutes = LocationRoutes;
  protected readonly BookingReferenceType = BookingReferenceType;
  protected readonly GetTypes = GetTypes;
  protected readonly BookingReferenceTypeLabels = BookingReferenceTypeLabels;
  protected readonly parseInt = parseInt;

  constructor(public PermissionService: PermissionService) {
  }

  protected readonly CompanyRoutes = CompanyRoutes;
  protected readonly Router = AppRoutes;
}
